<template>
  <el-select v-model="selectValue" @change="changeOption"
             :disabled="disabled" placeholder="请选择"
             class="common-width" :clearable="clearable" :filterable="filterable" :allowCreate="allowCreate">
    <el-option
      v-for="item in dictList"
      :key="item.value"
      :label="item.label"
      :value="item.value"/>
  </el-select>
</template>

<script>
import httpUtil from "../../utils/httpUtil";

export default {
  data() {
    return {
      selectValue: this.value,
      dictList: [],
    }
  },
  props: {
    /**
     * 默认选中值
     */
    value: {
      required: true
    },
    /**
     * 字典类型
     */
    dictCode: {
      type: String,
      required: true
    },
    /**
     * 是否可用
     */
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * 是否显示全部
     */
    all: {
      type: Boolean,
      default: false
    },
    /**
     * 是否允许清除
     */
    clearable: {
      type: Boolean,
      default: false
    },
    /**
     * 是否允许搜索
     */
    filterable: {
      type: Boolean,
      default: false
    },
    /**
     * 是否允许创建
     */
    allowCreate: {
      type: Boolean,
      default: false
    },
    /**
     * 字典值类型 默认字符串
     */
    valueType: {
      required: false,
      type: String,
      default: 'String'
    },
  },
  watch: {
    value: function (newVal) {
      if (newVal != null && newVal !== '') {
        if (this.valueType === 'String') {
          this.selectValue = newVal + ""
        } else {
          this.selectValue = newVal
        }
      } else {
        if (this.valueType === 'String') {
          this.selectValue = ''
        } else {
          this.selectValue = null;
        }
      }
    },
  },
  created() {
    this.initData()
  },
  methods: {
    changeOption(item) {
      this.$emit("update:value", item);
      this.$emit('change', item);
    },
    async initData() {
      if (this.valueType === 'String') {
        this.selectValue = this.value + ''
      } else {
        this.selectValue = this.value
      }
      if (this.dictCode !== '') {
        this.dictList = this.$store.state.dictionary[this.dictCode]
        if (this.dictList === undefined || this.dictList.length === 0) {
          this.dictList = await httpUtil.get('/sys/dictionary/getDictByType', {'type': this.dictCode});
        }
        if (this.valueType !== 'String') {
          this.dictList.forEach(item => {
            item.value = parseInt(item.value)
          })
        }
        if (this.all) {
          if (this.valueType === 'String') {
            this.dictList.unshift({label: "全部", value: ""})
          } else {
            this.dictList.unshift({label: "全部", value: null})
          }

        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/select/dict-select.vue